import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch, Action } from 'redux'
import { IApplicationState } from '../../rootReducer'
import Sidebar from '@SiteContainers/Sidebar'
import VocabulariesForm from '@SiteComponents/VocabulariesForm'
import Forwarder from '@SiteContainers/Forwarder'

import {
  IVocabulary,
  ICreateVocabularyPayload,
  IUpdateVocabularyPayload,
  IDeleteVocabularyPayload,
  IFetchVocabulariesPayload,
} from '@SiteModules/Vocabulary/types'

import {
  createVocabulary,
  updateVocabulary,
  deleteVocabulary,
  fetchVocabularies,
} from '@SiteModules/Vocabulary/actions'

import './Vocabularies.scss'

interface VocabulariesProps {
  readonly vocabularies: IVocabulary[]
  readonly hasLoadedInitially: boolean
  readonly loading: boolean
  readonly modifying: boolean
  readonly currentWorkspaceId: number
  fetchVocabularies(payload: IFetchVocabulariesPayload): void
  createVocabulary(payload: ICreateVocabularyPayload): void
  updateVocabulary(payload: IUpdateVocabularyPayload): void
  deleteVocabulary(payload: IDeleteVocabularyPayload): void
}

interface VocabulariesState {}

class Vocabularies extends React.Component<VocabulariesProps, VocabulariesState> {
  componentDidMount() {
    if (this.props.currentWorkspaceId >= 0 && !this.props.hasLoadedInitially) {
      this.props.fetchVocabularies({ workspaceId: this.props.currentWorkspaceId })
    }
  }

  componentDidUpdate(prevProps: VocabulariesProps) {
    if (prevProps.currentWorkspaceId !== this.props.currentWorkspaceId && this.props.currentWorkspaceId >= 0 && !this.props.hasLoadedInitially) {
      this.props.fetchVocabularies({ workspaceId: this.props.currentWorkspaceId })
    }
  }

  render() {
    const {
      vocabularies,
      loading,
      modifying,
    } = this.props

    return (
      <React.Fragment>
        <Forwarder />
        <div className="Vocabularies">
          <Sidebar
            pageName="vocabularies"
          />
          <div className="Vocabularies__main">
            <div className="Vocabularies__title">
              Vocabularies
            </div>
            <div className="Vocabularies__subtitle">
              Add words to improve the results of your projects.
            </div>
            {this.props.hasLoadedInitially && (
              <VocabulariesForm
                vocabularies={vocabularies}
                loading={loading}
                modifying={modifying}
                createVocabulary={this.props.createVocabulary}
                updateVocabulary={this.props.updateVocabulary}
                deleteVocabulary={this.props.deleteVocabulary}
                currentWorkspaceId={this.props.currentWorkspaceId}
              />
            )}
          </div>
        </div>
      </React.Fragment>
    )
  }
}

function mapStateToProps(state: IApplicationState) {
  const { vocabularies, workspaces } = state

  return {
    vocabularies: vocabularies.vocabularies,
    hasLoadedInitially: vocabularies.hasLoadedInitially,
    loading: vocabularies.loading,
    modifying: vocabularies.modifying,
    currentWorkspaceId: workspaces.currentWorkspaceId,
  }
}

function mapDispatchToProps(dispatch: Dispatch<Action>) {
  return bindActionCreators({
    fetchVocabularies,
    createVocabulary,
    updateVocabulary,
    deleteVocabulary,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Vocabularies)
